import { render, staticRenderFns } from "./Entry.vue?vue&type=template&id=e1063964&scoped=true"
import script from "./Entry.vue?vue&type=script&lang=js"
export * from "./Entry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1063964",
  null
  
)

export default component.exports